import { OutfitOption, PoseOption } from './types';

export const OUTFIT_OPTIONS: OutfitOption[] = [
  { id: 'suit_blue', label: 'ビジネススーツ（ネイビー）', prompt: '体型にフィットした無地のネイビーブルーのビジネススーツに白いシャツ', category: 'business', outfitImage: 'suit-navy' },
  { id: 'suit_black', label: 'ビジネススーツ（ブラック）', prompt: '体型にフィットした無地のブラックのビジネススーツに白いシャツ', category: 'business', outfitImage: 'suit-black' },
  { id: 'suit_light_gray', label: 'ビジネススーツ（ライトグレー）', prompt: '体型にフィットした無地のライトグレーのビジネススーツに白いシャツ', category: 'business', outfitImage: 'suit-light-gray' },
  { id: 'turtleneck_black', label: 'タートルネック（ブラック）', prompt: 'スタイリッシュな黒のタートルネックセーター', category: 'casual', outfitImage: 'turtleneck-black' },
  { id: 'shirt_white', label: 'カジュアルなシャツ（ホワイト）', prompt: 'シンプルで清潔感のある白いカジュアルシャツ', category: 'casual', outfitImage: 'shirt-white' },
  { id: 'aloha_shirt', label: 'アロハシャツ', prompt: '明るく華やかな柄のアロハシャツ', category: 'casual', outfitImage: 'aloha-shirt' },
  { id: 'custom_text', label: 'その他（テキストで指定）', prompt: '', category: 'custom', outfitImage: 'outfit-custom-text' },
  { id: 'custom_image', label: 'その他（衣装を添付する）', prompt: '', isPremium: true, category: 'custom', outfitImage: 'outfit-custom-image' },
];

export const BACKGROUND_OPTIONS = [
    { id: 'default', label: 'スタジオ (ニュートラル)' },
    { id: 'studio_white', label: 'スタジオ (白)' },
    { id: 'office', label: 'オフィス' },
    { id: 'outdoor', label: '屋外' },
    { id: 'custom', label: 'その他 (テキストで指定)' },
];

export const POSE_OPTIONS: PoseOption[] = [
  { id: 'front', label: '正面', prompt: '真っ直ぐに正面を向き、背筋を伸ばし、あごを軽く引き、柔らかな微笑みでカメラ目線。' },
  { id: 'slight_left', label: 'やや左向き', prompt: '背筋を伸ばし、あごを軽く引き、左に少し向きながら柔らかな微笑みでカメラ目線。' },
  { id: 'slight_right', label: 'やや右向き', prompt: '背筋を伸ばし、あごを軽く引き、右に少し向きながら柔らかな微笑みでカメラ目線。' },
  { id: 'left', label: '左向き', prompt: '背筋を伸ばし、あごを軽く引き、左を向いたプロフィールポーズで、上品で魅力的な横顔。' },
  { id: 'right', label: '右向き', prompt: '背筋を伸ばし、あごを軽く引き、右を向いたプロフィールポーズで、上品で魅力的な横顔。' },
  { id: 'lookback', label: '見返り', prompt: '肩越しに振り返るような自然なポーズで、少し後ろを振り返りながらもカメラに視線を向ける。首を軽く回転させ、上品で魅力的な見返りポーズ。' },
];